export { default as AutoRenewal } from "./AutoRenewal";



// WEBPACK FOOTER //
// ./src/containers/MyAdsPage/MyAds/AutoRenewal/index.ts